//Reference: EN056

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Entity extends Mappeable {

    idEntityPk: number;
    txtName: string;
    txtDescription: string;
    entamap: any;
    country: any;
    currency: any;
    typeOrganizationalStructure: any
    mrkActive: boolean;
    dateInsert: string;
    dateUpdate: string;
    userInsert: string;
    userUpdate: string;

    constructor(o) {
        super(o);
        this.typeOrganizationalStructure = _.isUndefined(this.typeOrganizationalStructure) || _.isNull(this.typeOrganizationalStructure) ? null : this.typeOrganizationalStructure;
        this.currency = _.isUndefined(this.currency) || _.isNull(this.currency) ? {} : this.currency;
        this.country = _.isUndefined(this.country) || _.isNull(this.country) ? {} : this.country;
        this.entamap = _.isUndefined(this.entamap) || _.isNull(this.entamap) || this.entamap === '' ? null : this.entamap;
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            country: this.country,
            currency: this.currency,
            mrkActive: this.mrkActive,
            entamap: this.entamap,
            typeOrganizationalStructure: this.typeOrganizationalStructure,
            txtName: this.txtName,
            txtDescription: "Default"
        }
    }
}